import Api from "../../../../services/Api";

function fetchEnergyConsumption(siteId, startTime, endTime) {
  return Api.get(
    `service/timeseries/evse/timeseries/site/per_device?site_id=${siteId}&start_date=${startTime}&resolution=custom&end_date=${endTime}`
  );
}

export { fetchEnergyConsumption };
